import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TimelineItem from "examples/Timeline/TimelineItem";
import TableVIPUsers from "./TableVIPUsers";

function OrdersOverview ({ vipUsers }) {
  return (
    <Card sx={{ height: "100%", padding: 0 }}>
      <MDBox pt={3} px={3}>
        <MDTypography variant='h6' fontWeight='medium'>
          VIP Customers
        </MDTypography>
      </MDBox>
      <MDBox pt={2}>
        <TableVIPUsers vipUsers={vipUsers} />
        {/* {vipUsers?.length > 0 &&
          vipUsers?.map(e => (
            <TimelineItem
              color='success'
              icon='person'
              title={e?.user.name}
              dateTime={e?.user?.email ? e?.user?.email : e?.user?.number}
            />
          ))} */}
      </MDBox>
    </Card>
  );
}

export default OrdersOverview;
